module.exports = __webpack_public_path__ + "static/media/icon_autonomo_active.442f116b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_autonomo_active.svg
// module id = 617
// module chunks = 0